import type { FlagGetter } from "@/FeatureFlag";
import type { User } from "@/components/users/types";
import { userIsCROAdmin } from "@/util";

export const TRAFFIC_FILTERS_PATH = "/settings/traffic-filters";

export function canViewTrafficFilters(
  flag: FlagGetter,
  user: User | undefined,
): boolean {
  return flag("trafficFilters") && userIsCROAdmin(user);
}
